module.exports = __webpack_public_path__ + "img/sheikh.e32e520e.png";